import { defineStore } from 'pinia';

const publicUrl = import.meta.env.VITE_PUBLIC_URL || 'http://localhost:80';

export const usePlaylistStore = defineStore('playlist', {
  state: () => ({
    // ... 其他狀態 ...
  }),
  actions: {
    // ... 其他 actions ...
    getMediaUrl(filename) {
      return `${publicUrl}/media/${encodeURIComponent(filename)}`;
    }
  }
}); 